import { createSelector } from 'reselect';
import type { RootState } from '../store';
import type { AuthState, Employee } from '../types';

export const getLicence = createSelector(
  (state: RootState) => state.auth as unknown as AuthState,
  (auth: AuthState): string | undefined =>
    (auth.employees || []).find(
      (employee: Employee) => employee?.company.id === auth?.current_company
    )?.company?.licence_plan
);
